import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
export default {
  props: {
    poId: Number,
    poItems: [],
    parentItem: {},
    ordersFillable: [],
    disabled: Boolean
  },
  data: function data(_this) {
    return {
      headers: [{
        text: "Order",
        value: "orderReference"
      }, {
        text: "Quantity",
        value: "quantity"
      }, {
        text: "Actions",
        value: "actions"
      }],
      form: {
        valid: false
      },
      dialog: false,
      dialogDelete: false,
      editedItem: {
        id: 0,
        orderId: 0,
        orderReference: "",
        quantity: 0
      },
      defaultItem: {},
      rules: formRules
    };
  },
  created: function created() {
    this.defaultItem = _objectSpread({}, this.editedItem);
    this.selectedItems = _toConsumableArray(this.parentItem.quantitiesForOrders);
  },
  computed: {
    formTitle: function formTitle() {
      return this.editedItem.id ? "Edit order quantity" : "Add order quantity";
    },
    ordersStillFillable: function ordersStillFillable() {
      var ordersIdAlreadyUsed = this.parentItem.quantitiesForOrders.map(function (x) {
        return x.orderId;
      });
      return this.ordersFillable.filter(function (x) {
        return !ordersIdAlreadyUsed.includes(x.orderId);
      });
    },
    maxAllowed: function maxAllowed() {
      var _this2 = this;
      var maxAllowed = this.parentItem.quantity;
      var alreadyDispatchOnOrdersWithThisItem = this.parentItem.quantitiesForOrders.reduce(function (acc, x) {
        if (_this2.editedItem.orderId > 0 && x.orderId == _this2.editedItem.orderId) return acc;else return acc + +x.quantity;
      }, 0);
      var alreadyDispatchOnReservationsWithThisItem = this.parentItem.reservations.reduce(function (acc, x) {
        return acc + +x.quantity;
      }, 0);
      maxAllowed -= alreadyDispatchOnOrdersWithThisItem + alreadyDispatchOnReservationsWithThisItem;
      var otherItemsSameWine = this.poItems.filter(function (x) {
        var _this2$parentItem;
        return x.wineId == _this2.parentItem.wineId && x.id != ((_this2$parentItem = _this2.parentItem) === null || _this2$parentItem === void 0 ? void 0 : _this2$parentItem.id);
      });
      var alreadyDispatchOnOrderWithOtherItemsSameWine = otherItemsSameWine.reduce(function (acc, x) {
        var _x$quantitiesForOrder;
        var alreadyDispatchOnOrdersWithItem = (_x$quantitiesForOrder = x.quantitiesForOrders.reduce(function (acc, qfo) {
          if (_this2.editedItem.orderId > 0 && qfo.orderId == _this2.editedItem.orderId) {
            return acc;
          } else {
            return acc + +qfo.quantity;
          }
        }, 0)) !== null && _x$quantitiesForOrder !== void 0 ? _x$quantitiesForOrder : 0;
        return acc + alreadyDispatchOnOrdersWithItem;
      }, 0);
      maxAllowed -= alreadyDispatchOnOrderWithOtherItemsSameWine;
      if (this.editedItem.orderId > 0) {
        var orderFillableAttached = this.ordersFillable.find(function (x) {
          return x.orderId == _this2.editedItem.orderId;
        });
        if (orderFillableAttached) {
          var _orderFillableAttache;
          var orderItemQuantity = orderFillableAttached.quantityToFill + ((_orderFillableAttache = orderFillableAttached.poFillingItems) === null || _orderFillableAttache === void 0 || (_orderFillableAttache = _orderFillableAttache.find(function (x) {
            return x.poId === _this2.poId;
          })) === null || _orderFillableAttache === void 0 ? void 0 : _orderFillableAttache.quantity);
          if (orderItemQuantity < maxAllowed) maxAllowed = orderItemQuantity;
        }
      }
      if (!this.editedItem.id && this.editedItem.orderId > 0) {
        var orderFillMax = this.ordersFillable.find(function (x) {
          return x.orderId == _this2.editedItem.orderId;
        }).quantityToFill;
        if (orderFillMax < maxAllowed) {
          maxAllowed = orderFillMax;
        }
      }
      return maxAllowed;
    },
    isAttachedToNotCompatibleOrder: function isAttachedToNotCompatibleOrder() {
      var _this$editedItem,
        _this3 = this;
      if (((_this$editedItem = this.editedItem) === null || _this$editedItem === void 0 ? void 0 : _this$editedItem.orderId) > 0) {
        var orderFillableAttached = this.ordersFillable.find(function (x) {
          return x.orderId == _this3.editedItem.orderId;
        });
        if (!orderFillableAttached) return true;
      }
      return false;
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    },
    dialogDelete: function dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    changeOrder: function changeOrder(value) {
      var orderChosen = this.ordersFillable.find(function (x) {
        return x.orderId == +value;
      });
      this.editedItem.orderReference = orderChosen.orderReference;
      if (!this.editedItem.quantity) this.editedItem.quantity = orderChosen.quantityToFill;
      this.changeQuantity(this.editedItem.quantity);
    },
    changeQuantity: function changeQuantity(value) {
      if (+value > this.maxAllowed) {
        this.editedItem.quantity = this.maxAllowed;
        this.$toasted.show("There is not enough quantity ordered to fill this order, or not enough for the requested quantity", {
          type: "warning"
        });
      }
    },
    editItem: function editItem(item) {
      this.editedItem = _objectSpread(_objectSpread({}, item), {}, {
        isBeingEdited: true
      });
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm: function deleteItemConfirm() {
      this.selectedItems.splice(this.selectedItems.indexOf(this.editedItem), 1);
      this.closeDelete();
      this.$emit("save", this.selectedItems);
    },
    close: function close() {
      var _this4 = this;
      this.dialog = false;
      this.$nextTick(function () {
        _this4.editedItem = _objectSpread({}, _this4.defaultItem);
      });
    },
    closeDelete: function closeDelete() {
      var _this5 = this;
      this.dialogDelete = false;
      this.$nextTick(function () {
        _this5.editedItem = _objectSpread({}, _this5.defaultItem);
      });
    },
    save: function save() {
      var _this6 = this;
      var editedIndex = this.selectedItems.findIndex(function (x) {
        return x.orderId === _this6.editedItem.orderId;
      });
      if (editedIndex > -1) {
        this.selectedItems.splice(editedIndex, 1, _objectSpread({}, this.editedItem));
      } else {
        this.selectedItems = [].concat(_toConsumableArray(this.selectedItems), [_objectSpread({}, this.editedItem)]);
      }
      this.close();
      this.editedItem = this.defaultItem;
      this.$emit("save", this.selectedItems);
    },
    filterVAutocomplete: filterVAutocomplete
  }
};